module.exports = __webpack_public_path__ + "ClientApp/images/content/mobile/Student_Externship_Masthead.png";